import React, { Component } from 'react';
import xtend from 'xtend';

/**
 * This HOC handles the following:
 *
 * - The creation of Events
 *
 * - The Creation of Categories found within a CSV which do not already exist
 * within the Client's pool of global Categories (run before the Event creation
 * process)
 */
export default function ImporterApiDelegate (WrappedComponent) {
    return class extends Component {
        constructor (props) {
            super(props);

            this.state = {};

            this.createEvents = this.createEvents.bind(this);
        }

        createEvents () {}

        render () {
            return React.createElement(
                WrappedComponent,
                xtend({}, this.props),
                this.props.children || []
            );
        }
    };
}
